import React from 'react';
import { compose, mapProps } from 'recompose';
import { InPageMessageComponent } from '../../../components/in-page-message';
import { insertVarIntoString } from '../../../helpers/insert-var-into-string';
import { Grid, Column } from '../../../components/layout/grid';
import styles from '../../../styles/widgets/points/vm-points-message.module.scss';

const Component = React.memo(({ text }) => (
  <Grid className={styles.container}>
    <Column>
      <InPageMessageComponent html={text} />
    </Column>
  </Grid>
));

export const PointsMessage = compose(
  mapProps(({ text, points }) => ({
    text: insertVarIntoString(
      text,
      {
        points: points
      },
      'strong'
    )
  }))
)(Component);
